import { renderSlot as _renderSlot, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("button", {
    class: ["w-full px-2 py-2 text-left hover:bg-gray-100", [
      { 'border-b': _ctx.hasBorder },
      { 'cursor-not-allowed text-gray-400': _ctx.disabled }
    ]],
    disabled: _ctx.disabled,
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args)))
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 10, ["disabled"]))
}